import { GraphQLError } from "graphql";
export var AxiosGraphQLError = function AxiosGraphQLError(message, graphErrorOpts, response) {
    "use strict";
    this.message = message;
    this.graphQlError = new GraphQLError(message, graphErrorOpts);
    this.response = response;
    this.config = response.config;
};
